<template>
  <div>
    <notification-modal
      v-if="notificationModalState"
      :notification="notification"
      :isBaseModal="isBaseModal"
      :isPopupModal="isPopupModal"
      @close="modalClose"
    >
    </notification-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import NotificationModal from './NotificationModal';

export default {
  name: 'NotificationComponent',
  components: { NotificationModal },
  props: {},
  data() {
    return {
      notification: {},
      notificationModalState: false,
    };
  },
  computed: {
    ...mapGetters('notifications', {
      notifications: 'getNotifications',
    }),
    isBaseModal: function () {
      return [
        'App\\Notifications\\CustomPopupNotification',
        'App\\Notifications\\ResetCoinsNotification',
        'App\\Notifications\\ResetFreeCoinsNotification',
        'App\\Notifications\\LeavePaymentNotification',
        'App\\Notifications\\MatchGameSwitchNotification',
      ].includes(this.notification.type);
    },
    isPopupModal: function () {
      return [
        'daily_reward',
      ].includes(this.notification.type);
    },
  },
  watch: {
    notifications(notifications) {
      if (this.notificationModalState) {
        return;
      }

      if (notifications.length) {
        this.notification = notifications[0];

        this.$nextTick(() => {
          this.notificationModalState = true;
        });
        this.markAsRead(this.notification);
      }
    },
  },
  methods: {
    modalClose(notification) {
      this.notificationModalState = false;
      this.$store.commit('notifications/removeNotification', notification);
    },
    markAsRead(notification) {
      if (!this.isPopupModal) {
        return axios
          .post(zRoute('ajax.user.notifications.read', notification.id));
      }
    }
  },
};
</script>
